<script setup>
// BonBoZ: thẻ nhỏ "Không còn là bạn bè" ở thời điểm huỷ kết bạn Zalo.
import { computed } from 'vue';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import { useMessageContext } from '../provider.js';
import { gioBuoc } from 'dashboard/helper/zaloKetBan';

const { contentAttributes } = useMessageContext();

const the = computed(() => contentAttributes.value?.bonbozZaloHuyKetBan || {});
const phu = computed(() =>
  [the.value.khach?.ten, the.value.khach?.sdt, gioBuoc(the.value.luc)]
    .filter(Boolean)
    .join(' · ')
);
</script>

<template>
  <div
    class="flex items-center gap-2 w-[min(370px,calc(100cqw-5rem))] mx-auto px-3 py-2 rounded-xl border border-n-weak bg-n-solid-1 text-n-slate-12"
    data-bubble-name="zalo-huy-ket-ban"
  >
    <Avatar
      :src="the.khach?.avatar || ''"
      :name="the.khach?.ten || '?'"
      :size="28"
      rounded-full
    />
    <div class="flex-1 min-w-0">
      <div class="text-sm font-semibold truncate">
        {{ $t('BONBOZ.KET_BAN.HUY_TIEU_DE') }}
      </div>
      <div class="text-xs text-n-slate-11 truncate">{{ phu }}</div>
    </div>
    <span
      class="px-2 py-0.5 rounded-full text-xs font-medium bg-n-slate-3 text-n-slate-11 shrink-0"
    >
      {{ $t('BONBOZ.KET_BAN.ZALO') }}
    </span>
  </div>
</template>
